import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
const ImageComponent = ({ imagepath, typePhoto }) => {

    const [imageSrc, setImageSrc] = useState('');

    useEffect(() => {

        fetch('https://api.swarnapanchayat.apcfss.in/panchayatrajdms/file-download/' + imagepath)
            .then(response => response.blob())
            .then(imageBlob => {
                const imageObjectURL = URL.createObjectURL(imageBlob);
                setImageSrc(imageObjectURL);
            })
            .catch();

    }, [imagepath]);




    if (typePhoto == "cbn") {
        return <img src={imageSrc} alt="Logo" className='cbn-img' />
    }
    if (typePhoto == "pspk") {
        return <img src={imageSrc} alt="Logo" className='cbn-img' />
    }

    if (typePhoto == "housetaxmain") {
        return <Card.Img variant="top" src={imageSrc} className='tax-img pt-4' />
    }
    if (typePhoto == "logo") {
        return <img src={imageSrc} className='logo' />
    }
    if (typePhoto == "logotext") {
        return <img src={imageSrc} className='logo-text' width={"100px"} height={"40px"} />
    }
    if (typePhoto == "usermanual") {
        return <img src={imageSrc} className="img-fluid" />
    }
    if (typePhoto == "viedeo") {
        return <img src={imageSrc} className="img-fluid" />
    }
    if (typePhoto == "profoma") {
        return <img src={imageSrc} className="img-fluid" />
    }
    if (typePhoto == "forest") {
        return <img src={imageSrc} />
    }
    if (typePhoto == "fishers") {
        return <img src={imageSrc} />
    }
    if (typePhoto == "industries") {
        return <img src={imageSrc} />
    }
    if (typePhoto == "agriculture") {
        return <img src={imageSrc} />
    }
    if (typePhoto == "noopener") {
        return <img src={imageSrc} />
    }
    if (typePhoto == "image") {
        return <img src={imageSrc} alt="Gallery" className="gallery-image" />
    }
    if(typePhoto=="SVAMITVA"){
         return <img src={imageSrc} alt="SVAMITVA"  style={{ height: "100px", width: "100px" }}/>
       
    }



};

export default ImageComponent;

export function DmsImageview(imageurl, typeformat) {


    axios("https://api.swarnapanchayat.apcfss.in/panchayatrajdms/file-download/" + imageurl, {
        method: 'GET',
        responseType: 'blob',
        mode: 'no-cors'
    }).then(response => {
        let formatchange = "";
        if (typeformat === "IMG") {
            formatchange = 'image/jpeg';
        } else if (typeformat === "PDF") {
            formatchange = 'application/pdf';
        }
        else if (typeformat === "PNG") {
            alert('success')
            formatchange = 'image/png';
        }
        else if (typeformat === "MP4") {
            formatchange = 'video/mp4';
        }

        else if (typeformat === "XLS") {
            formatchange = 'application/vnd.ms-excel';
        }

        else if (typeformat === "TXT") {
            formatchange = 'text/plain';
        }

        const file = new Blob(
            [response.data],
            { type: formatchange });

        const fileURL = URL.createObjectURL(file);

        window.open(fileURL, "_blank");
    }).catch();
}

export function DmsImageViewInIFrame(imageurl, typeformatb, setPdfUrl, setShowPdfModal) {
    axios("https://api.swarnapanchayat.apcfss.in/panchayatrajdms/file-download/" + imageurl, {
        method: 'GET',
        responseType: 'blob',
        mode: 'no-cors'
    }).then(responseb => {
        let formatchangeb = "";
        if (typeformatb === "IMG") {
            formatchangeb = 'image/jpeg';
        } else if (typeformatb === "PDF") {
            formatchangeb = 'application/pdf';
        }
        else if (typeformatb === "PNG") {
            alert('success')
            formatchangeb = 'image/png';
        }
        else if (typeformatb === "MP4") {
            formatchangeb = 'video/mp4';
        }

        else if (typeformatb === "XLS") {
            formatchangeb = 'application/vnd.ms-excel';
        }

        else if (typeformatb === "TXT") {
            formatchangeb = 'text/plain';
        }
         

        const fileb = new Blob(
            [responseb.data],
            { type: formatchangeb });

        const fileURLb = URL.createObjectURL(fileb);

       // window.open(fileURL, "_blank");
         // ✅ instead of window.open
      setPdfUrl(fileURLb);
      setShowPdfModal(true);
    }).catch();
}

// export const ViedeoDetails = ({ imagepath, typePhoto }) => {

//     const [imageSrc, setImageSrc] = useState('');

//     useEffect(() => {

//         fetch('https://api.swarnapanchayat.apcfss.in/panchayatrajdms/file-download/' + imagepath)
//             .then(response => {
//                 const contentType = response.headers.get('Content-Type');

//                 // Check if the content type is an image or video
//                 if (contentType && (contentType.includes('image/') || contentType === 'video/mp4')) {
//                     return response.blob();
//                 } else {
//                     throw new Error('Unsupported file type');
//                 }
//             })
//             .then(fileBlob => {
//                 const fileObjectURL = URL.createObjectURL(fileBlob);

//                 // Check if it's an image or video and handle accordingly
//                 const contentType = fileBlob.type;
//                 if (contentType.includes('image/')) {
//                     // Display image
//                     setImageSrc(fileObjectURL);  // Assuming setImageSrc is used to display images
//                 } else if (contentType === 'video/mp4') {
//                     // Create a video element for MP4
//                     const videoElement = document.createElement('video');
//                     videoElement.src = fileObjectURL;
//                     videoElement.controls = true; // Add video controls
//                     document.body.appendChild(videoElement);  // Append video to body or any container
//                 }
//             })
//             .catch(err => console.error('Fetch error:', err));


//     }, [imagepath]);


//     if (typePhoto == "viedeo") {
//         return <source src={imageSrc} />
//     }

// }



